import apiClient, { ACCEPT_TYPES } from "../../services/ApiClientService";
import { dataLoading } from "../decorators/LoadingAction.decorator";
import { SurchargeDetailForEdit } from "../models/SurchargeDetailForEdit";
import { SurchargeEventCalculation } from "../models/SurchargeEventCalculation";
import { SurchargeEventCalculationResult } from "../models/SurchargeEventCalculationResult";
import { SurchargeEventCalculationRun } from "../models/SurchargeEventCalculationRun";
import { Utilities } from "../utils/utilities";

export class ReviewNewChargesApi {
  @dataLoading(undefined)
  static async listCalculatedEvents() {
    var result = await apiClient.get("/api/surcharge/listCalculatedEvents");
    if (result.status === 200) {
      var calculatedEvents = result.data as SurchargeEventCalculation[];
      if (calculatedEvents) {
        calculatedEvents.forEach((item) => {
          item.mDate = new Date(item.highestCalendarMonth);
          item.displayData = `${item.surchargeType} - ${item.name}`;
        });
        calculatedEvents.sort((a, b) => Utilities.dateComparison(a.mDate, b.mDate));
      }

      return calculatedEvents;
    } else {
      return undefined;
    }
  }

  @dataLoading(undefined)
  static async listCalculatedEventRuns(selectedSurchargeEventId: string) {
    var result = await apiClient.get(`/api/surcharge/listCalculatedEventRuns?surchargeEventId=${selectedSurchargeEventId}`);
    if (result.status === 200) {
      var calculatedEventRuns = result.data as SurchargeEventCalculationRun[];
      if (calculatedEventRuns) {
        calculatedEventRuns.forEach((item) => {
          item.runTimeDate = new Date(item.runTime);
          item.displayData = `${item.runTimeDate.toLocaleDateString("en-US")} - Update Day : ${item.updateDay} - Run By : ${item.runBy}`;
        });
        calculatedEventRuns.sort((a, b) => Utilities.dateComparison(a.runTimeDate, b.runTimeDate));
      }

      return calculatedEventRuns;
    } else {
      return undefined;
    }
  }

  @dataLoading([])
  static async showCalculatedEventRun(selectedCalculatedEventRunId: string) {
    if (Utilities.isNullOrEmptyString(selectedCalculatedEventRunId)) {
      return [];
    }

    var result = await apiClient.get(`/api/surcharge/showSurchargeEventCalculationResults?surchargeEventCalculationId=${selectedCalculatedEventRunId}`);
    if (result.status === 200) {
      return result.data as SurchargeEventCalculationResult[];
    } else {
      return [];
    }
  }

  @dataLoading(false)
  static async approveSurcharge(selectedCalculatedEventRunId: string) {
    var result = await apiClient.get(`/api/surcharge/approveSurcharge?surchargeEventCalculationId=${selectedCalculatedEventRunId}`);
    return result.status === 200 || result.status === 204;
  }

  @dataLoading("")
  static async getSurchargeEventCalculationLog(selectedCalculatedEventRunId: string) {
    var result = await apiClient.get(`/api/surcharge/getSurchargeEventCalculationLog?surchargeEventCalculationId=${selectedCalculatedEventRunId}`);
    return result ? Utilities.blobFileDownload(result) : "";
  }

  @dataLoading("")
  static async dumpSurchargeEventCalculationResults(selectedCalculatedEventRunId: string) {
    var result = await apiClient.get(`/api/surcharge/dumpSurchargeEventCalculationResults?surchargeEventCalculationId=${selectedCalculatedEventRunId}`);
    return result ? Utilities.blobFileDownload(result) : "";
  }

  @dataLoading("")
  static async exportToSapFormat(selectedCalculatedEventRunId: string) {
    var result = await apiClient.get(`/api/surcharge/exportToSapFormat?surchargeEventCalculationId=${selectedCalculatedEventRunId}`, { responseType: "arraybuffer", headers: { Accept: ACCEPT_TYPES.binary } });
    return result ? Utilities.blobFileDownload(result) : "";
  }

  @dataLoading(undefined)
  static async surchargeReviewRetrieveForEdit(surchargeDetailRowId: string) {
    var result = await apiClient.get(`/api/surcharge/surchargeReviewRetrieveForEdit?surchargeEventCalculationResultId=${surchargeDetailRowId}`);
    if (result.status === 200) {
      return result.data;
    } else {
      return undefined;
    }
  }

  @dataLoading(false)
  static async revokeApproval(id: string) {
    var result = await apiClient.get(`/api/surcharge/revokeApproval?surchargeEventCalculationResultId=${id}`);
    return result.status === 200 || result.status === 204;
  }

  @dataLoading(false)
  static async applyCalculationResultChanges(surchargeDetail: SurchargeDetailForEdit) {
    var transformedSurchargeDetail = Utilities.transformObjectToCapitalizeFirstLetter(surchargeDetail);
    transformedSurchargeDetail.SAPEnergySurchargeCode = surchargeDetail.sapEnergySurchargeCode;
    transformedSurchargeDetail.SAPMaterialProductCode = surchargeDetail.sapMaterialProductCode;
    transformedSurchargeDetail.UOM = surchargeDetail.uom;
    var result = await apiClient.post(`/api/surcharge/applyCalculationResultChanges`, transformedSurchargeDetail);
    return result.status === 204;
  }
}
